import { render, staticRenderFns } from "./CreateOpenRouterChannelForm.vue?vue&type=template&id=b2484682&scoped=true"
import script from "./CreateOpenRouterChannelForm.vue?vue&type=script&lang=js"
export * from "./CreateOpenRouterChannelForm.vue?vue&type=script&lang=js"
import style0 from "./CreateOpenRouterChannelForm.vue?vue&type=style&index=0&id=b2484682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2484682",
  null
  
)

export default component.exports